export const lengthExceededErrorCodes  = [
  //OData Error Codes
  'EditorialTooMuchAdTextInTitle',
  'EditorialTooMuchAdTextInText',
  'EditorialTooMuchAdTextInDisplayUrl',
  'EditorialTooMuchAdTextInDestinationUrl',
  'EditorialDefaultAdTooMuchAdTextInText',
  'EditorialTooMuchAdTextInTextAcrossAllAssociations',
  'EditorialTooMuchAdTextInTitleAcrossAllAssociations',
  'EditorialTooMuchAdTextInDisplayUrlAcrossAllAssociations',

  //Bulk Error Codes
  'CampaignServiceTooMuchAdTextInTitle',
  'CampaignServiceTooMuchAdTextInText',
  'CampaignServiceTooMuchAdTextInDisplayUrl',
  'CampaignServiceTooMuchAdTextInDestinationUrl',
  'CampaignServiceDefaultAdTooMuchTextInText',
  'CampaignServiceTooMuchTextInTextAcrossAllAssociations',
  'CampaignServiceTooMuchTextInTitleAcrossAllAssociations',
  'CampaignServiceTooMuchTextInDisplayUrlAcrossAllAssociations',
];
